import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-navy text-white py-16 md:py-24 overflow-hidden relative" data-id="element-82">
      {/* Background subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-83" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-84">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-85">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-86">
            <div className="inline-block px-4 py-1.5 rounded-full border border-gold/30 bg-gold/10 text-gold text-sm font-semibold tracking-wide mb-6" data-id="element-87">
              ✨ Método 2026
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-88">
              Descubre 3 Mini-Negocios Digitales que puedes empezar{' '}
              <span className="text-gold" data-id="element-89">desde tu celular</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-90">
              Sin experiencia previa. Sin complicaciones técnicas. Solo tu
              celular y las ganas de empezar.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-91">
              <CTAButton className="w-full sm:w-auto text-lg" data-id="element-92">
                QUIERO EMPEZAR AHORA
              </CTAButton>

              <div className="flex flex-wrap justify-center lg:justify-start gap-4 mt-4 text-sm text-gray-400" data-id="element-93">
                <div className="flex items-center gap-1.5" data-id="element-94">
                  <ZapIcon className="w-4 h-4 text-gold" data-id="element-95" />
                  <span data-id="element-96">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-97">
                  <ShieldCheckIcon className="w-4 h-4 text-gold" data-id="element-98" />
                  <span data-id="element-99">Paso a paso simple</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-100">
                  <SmartphoneIcon className="w-4 h-4 text-gold" data-id="element-101" />
                  <span data-id="element-102">Desde tu celular</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-103">
            <div className="absolute inset-0 bg-gradient-to-tr from-gold/20 to-transparent blur-2xl rounded-3xl transform rotate-3" data-id="element-104" />
            <img src="https://cdn.magicpatterns.com/uploads/4EhZYLC9XTmbCGKjZV8qW8/IA_Expres_3_mini_negocios.png" alt="IA Exprés 2026 - 3 Mini-Negocios Digitales" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-white/10" data-id="element-105" />
          </motion.div>
        </div>
      </div>
    </section>;
}